export const inviteVendorResponse = {
  success: true
};
